export interface CreatePreSignedUrlRequest {
  original_name: string;
}

export interface CreatePreSignedUrlResponse {
  upload_url: string;
  file_path: string;
  id: string;
}

export interface PlaybackUrlResponse {
  playback_url: string;
  file_path: string;
  expires_in: number;
}

export interface DeleteUploadResponse {
  id: string;
  state: string;
}

export enum FileType {
  WORKOUT_VIDEO = "workout_video",
}

export enum FileExtension {
  MP4 = "mp4",
  WEBM = "webm",
  MOV = "mov",
}

export const getFileExtension = (filename: string): FileExtension | null => {
  const extension = filename.split(".").pop()?.toLowerCase();
  if (extension === FileExtension.MP4) return FileExtension.MP4;
  if (extension === FileExtension.WEBM) return FileExtension.WEBM;
  if (extension === FileExtension.MOV) return FileExtension.MOV;
  return null;
};

export interface WorkoutVideoAsset {
  id: string;
  file_path: string;
  original_name: string;
  file_type: string;
  extension: string | null;
  state: string;
  created_by: string;
  created_at: string;
  linked_catalog_ids: string[];
}

export interface WorkoutAssetListResponse {
  assets: WorkoutVideoAsset[];
}
